import Button from '@v2/shared/components/Button';
import Container from '@v2/shared/components/Container';
import { faLongArrowRight } from '@fortawesome/pro-regular-svg-icons';

type Props = {
  href: string;
};

/**
 * The way back to the landing page, pinned to the bottom of the viewport.
 *
 * The catalogue is the argument and this is the ask, so it stays in view while the visitor
 * scrolls it — which is what it did at the source. An anchor rather than a button: it goes
 * to another page, and a middle click should open it.
 *
 * The copy is headless_jshop's, and it is not Magzter Gold's. That page sends you to a
 * pricing table and says "Choose Your Plan"; this one sends you to a page that opens with
 * a free month, so it says so.
 */
export default function PlanCta({ href }: Props) {
  return (
    <div className="sticky bottom-2 lg:bottom-4 z-10 pointer-events-none">
      <Container className="flex justify-center lg:justify-end">
        <div className="pointer-events-auto w-full lg:w-auto bg-white p-5 lg:pt-4 rounded-2xl shadow-lg flex flex-col items-center">
          <div className="hidden lg:block font-bold text-2xl text-center mb-4">
            Try ZINIO Unlimited Today
          </div>
          <a href={href} className="w-full max-w-md">
            <Button size="lg" iconAfter={faLongArrowRight} fullWidth>
              Start free 1-month trial
            </Button>
          </a>
        </div>
      </Container>
    </div>
  );
}
